import React from 'react';
import Slider from 'react-slick';
import { Headline } from './headline';

const settings = {
  dots: true,
  infinite: true,
  speed: 3000,
  autoplaySpeed: 6000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  vertical: false,
  customPaging: () => (
    <button className="slick-button">
      <span />
    </button>
  )
};

export default class HeadlinesSlider extends React.Component {
  render = () => <Slider {...settings}>{this.renderHeadlines()}</Slider>;

  renderHeadlines = () =>
    this.props.headlines.map((headline, index) => {
      return <Headline key={index} {...headline} />;
    });
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/headlines_slider/headlines_slider.jsx